var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.786 18.793h-2.88V14.97c0-.777-.686-1.409-1.53-1.409H11.29c-.844 0-1.535.632-1.535 1.409v3.822H7.014a.205.205 0 01-.202-.201v-7.75l5.562-5.403 5.55 5.194.064 7.959a.205.205 0 01-.202.2zm1.297-8.667a.62.62 0 00-.137-.193l-6.164-5.77a.606.606 0 00-.836.009l-6.16 5.982a.645.645 0 00-.138.198.6.6 0 00-.044.22c-.003.009-.004 2.682-.004 8.02 0 .776.634 1.408 1.414 1.408h3.348c.335 0 .606-.27.606-.604 0-.02-.004-.044-.004-.064 0-.024.004-.044.004-.068V14.97c0-.08.125-.202.323-.202h2.084c.198 0 .32.121.32.202v4.293c0 .024.008.044.008.068 0 .02-.008.044-.008.064 0 .334.274.604.605.604h3.486c.78 0 1.414-.632 1.414-1.412l-.069-8.224a.668.668 0 00-.048-.238z"
  })));
};

export default SvgHome;